import type { AiCostDimension } from '@Application/AiCosts/AiCostDimension';
import aiCostsFiltersSignal, {
	setAiCostsFilters,
} from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import type { SubjectLabel } from '@UI/Pages/Administration/AiCosts/CostTabs/Shared/Helpers/resolveSubjectLabel';
import type AiCostBreakdownRowView from '@UI/Store/AiCosts/Views/AiCostBreakdownRowView';

export type DrillAction = {
	readonly ariaLabel: string;
	readonly run: () => void;
};

/** What a click on a row opens: a facility its users, a structure its facilities. `null` when the row leads nowhere. */
const resolveDrillAction = (
	dimension: AiCostDimension,
	row: AiCostBreakdownRowView,
	subject: SubjectLabel,
): DrillAction | null => {
	const subjectId = row.subjectId;

	if (subjectId === null || row.isSubjectDeleted) {
		return null;
	}

	if (dimension === 'facilities') {
		return {
			ariaLabel: `Voir les utilisateurs de ${subject.title}`,
			run: () =>
				setAiCostsFilters(aiCostsFiltersSignal.peek().drillDown('users', { facilityId: subjectId })),
		};
	}

	if (dimension === 'organizations') {
		return {
			ariaLabel: `Voir les agences de ${subject.title}`,
			run: () =>
				setAiCostsFilters(
					aiCostsFiltersSignal.peek().drillDown('facilities', { organizationId: subjectId }),
				),
		};
	}

	return null;
};

export default resolveDrillAction;
